import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetectScreenService {

  constructor() { }

  public isMobileScreen(): boolean {
    return window.innerWidth < 768;
  }
}
